export default {
  fluidActionCode: { field: 'code' },
  fluidActionId: { field: 'fluidActionId' },
  fluidActionName: { field: 'fluidActionName' }
};
